<app-gallery-settings-customize-header
  title="Layout"
  location="theme-layout-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group>
  <app-layout-preview [gallery]="gallery()"></app-layout-preview>
</app-gallery-settings-group>

<app-gallery-settings-group title="Assets">
  <app-theme-grid-layout-item [gallery]="gallery()"></app-theme-grid-layout-item>
  <app-theme-asset-size-item [gallery]="gallery()"></app-theme-asset-size-item>
  <app-theme-asset-spacing-item [gallery]="gallery()"></app-theme-asset-spacing-item>
  <app-theme-show-filenames-item [gallery]="gallery()"></app-theme-show-filenames-item>
  <app-theme-rounded-corners-item [gallery]="gallery()"></app-theme-rounded-corners-item>
</app-gallery-settings-group>

<app-gallery-settings-group title="Section">
  <app-theme-section-width-item [gallery]="gallery()"></app-theme-section-width-item>
  <app-theme-section-vertical-spacing-item [gallery]="gallery()"></app-theme-section-vertical-spacing-item>
  <app-theme-layout-background-color-item [gallery]="gallery()"></app-theme-layout-background-color-item>
</app-gallery-settings-group>
